import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_colored_entry_list = _resolveComponent("ontos-colored-entry-list")!
  const _component_ontos_named_list_input = _resolveComponent("ontos-named-list-input")!

  return (_openBlock(), _createBlock(_component_ontos_named_list_input, {
    ref: "identity",
    name: _ctx.value.name,
    alias: _ctx.value.alias,
    "name-label": _ctx.$tt('domain-name'),
    "fixed-alias": _ctx.fixedAlias,
    "start-with-auto-alias": _ctx.startWithAutoAlias,
    siblings: _ctx.domains,
    "onUpdate:name": _cache[1] || (_cache[1] = ($event: any) => (_ctx.patch('name', $event))),
    "onUpdate:alias": _cache[2] || (_cache[2] = ($event: any) => (_ctx.patch('alias', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ontos_colored_entry_list, {
        ref: "options",
        editable: "",
        reorderable: "",
        min: 1,
        entries: _ctx.value.options,
        title: _ctx.$tt('options'),
        level: 3,
        dense: "",
        "create-label": _ctx.$tt('option-create'),
        "onUpdate:entries": _cache[0] || (_cache[0] = ($event: any) => (_ctx.patch('options', $event)))
      }, null, 8, ["entries", "title", "create-label"])
    ]),
    _: 1
  }, 8, ["name", "alias", "name-label", "fixed-alias", "start-with-auto-alias", "siblings"]))
}